import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-step-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './step-bar.component.html',
  styleUrls: ['./step-bar.component.scss']
})
export class StepBarComponent {
  @Input() steps: string[] = [];
  @Input() currentStep = 1;

  getStepState(n: number): 'active' | 'done' | 'pending' {
    if (n === this.currentStep) return 'active';
    if (n < this.currentStep) return 'done';
    return 'pending';
  }
}
